export default {
  name: 'Upstairs Bedroom',
  id: 'UpstairsBedroom',
  data: [
    {
      title:
        'Fabric is placed over a lamp to soften the light, causing a fire hazard.',
      icon1: '/static/svgs/second-floor-bedroom/bedroom-2.svg',
      answers: [
        'Bring valuable items upstairs to protect from flood damage.',
      ],
      correctAnswerIndex: 1,
      position: {
        x: 0.2,
        y: 5.2,
        z: 0.4
      },
      completed: false
    },
    // {
    //   title:
    //     'A wet towel is lying in the floor, creating an opportunity for mold to grow.',
    //   icon1: '/static/svgs/second-floor-bedroom/towel-on-floor.svg',
    //   answers: [
    //     'Move the towel to a dirty clothes basket.',
    //   ],
    //   correctAnswerIndex: 2,
    //   position: {
    //     x: 1,
    //     y: 5,
    //     z: 1
    //   },
    //   completed: false
    // },
    // {
    //   title: 'Dust has accumulated on the blades of the fan.',
    //   icon1: '/static/svgs/second-floor-bedroom/dust-on-fan.svg',
    //   answers: [
    //     'Turn the fan on high speed so that the dust flies off.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: 0.6,
    //     y: 6,
    //     z: 1.25
    //   },
    //   completed: false
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/secondFloor/Bedroom.js